import { NodeProcess } from 'configTypes';
import StatusType from 'store/enums/StatusType';

declare const process: NodeProcess;

// This is the only non-react-app env variable supported.
const isProduction: boolean = process.env.NODE_ENV === 'production';

// Environment variables besides NODE_ENV must begin with REACT_APP_
//   to be compiled into the webpack for static deploys.
export const semiProxyBaseUrl = process.env.REACT_APP_SEMI_PROXY_URL || 'http://localhost:5000';
export const buildVersion = process.env.REACT_APP_BUILD_VERSION || 'Number.Hash';
export const useProdNetsuite = !!process.env.REACT_APP_USE_NETSUITE_PROD || false;

const secondsToMillis = (seconds: number): number => {
  return seconds * 1000;
};

export const conf = {
  isProduction: isProduction,
  useXHRLogger: false,
  buildVersion: buildVersion,
  staticRoot: '/index.html',
  httpRetryInterval: secondsToMillis(3),
  httpRequestTimeout: secondsToMillis(30),
  httpRetryLimit: 0,
  httpRequestTimeoutRetryLimit: 5,
  defaultDownloadedFileName: 'semi-download',
  defaultErrMessage:
    '<p>An error occurred.<br/><br/>Please submit a support request <a href="https://835472.extforms.netsuite.com/app/site/crm/externalcasepage.nl/compid.835472/.f?formid=27&h=AACffht_l7hreHQQmYrgcvmHTr2zW2LVllQ&redirect_count=1&did_javascript_redirect=T">here</a>.',
  authErrMessage: 'Your session has expired or you are not logged in. Please sign in and try again.',
  programCommitteeId: '20',
  noCompany: 'A member company record was not found linked to your email address domain.',
  active: 'Active' as StatusType,
  inactive: 'Inactive' as StatusType,
  filenameHeader: 'x-suggested-filename',
  defaultLanguage: 'en_US',
  defaultCountry: 'US',
  minPassLength: 8,
  maxPassLength: 128,
  minPhoneLength: 7,
  tinyMCEApiKey: '1lglnucpwob9jegresyjsftlws4n4ttwzpw7lnit54xbvytg',
  netSuite: {
    semiEmailKey: 'https://semi.org/email',
    semiIsStaffKey: 'isStaff',
    customerScriptId: useProdNetsuite ? 1509 : 1509,
    customerRecordType: 'customer',
    companiesScriptId: useProdNetsuite ? 1512 : 1512,
    affiliatesScriptId: useProdNetsuite ? 1514 : 1514,
    committeesUpdateScriptId: useProdNetsuite ? 1511 : 1511,
    standardsBallotsScriptId: useProdNetsuite ? 1529 : 1529,
    standardsBallotsVotesScriptId: useProdNetsuite ? 1530 : 1530,
    customerDownloadScriptId: useProdNetsuite ? 1528 : 1528,
  },
  proxyEndpoints: {
    semiNetSuite: '/api/request',
    passwordUpdate: '/api/password',
    logs: '/api/logs',
    fileUpload: '/api/upload',
    semiNetSuiteAnonymous: '/api/request-anonymous',
    virtualMeeting: '/api/virtual-meeting',
    ballotVoting: '/api/ballot-voting',
  },
  auth0: {
    // url: 'https://semi-org.auth0.com/api/v2/users/USER_ID',
    // domain: 'accounts.semi.org',
    // clientId: '6ybxRpBoarwWLKn5bKLyMzIZiLZyqebo',
    // responseType: 'token id_token'
    url: useProdNetsuite
      ? 'https://semi-org.auth0.com/api/v2/users/USER_ID'
      : 'https://semi-org-dev.us.auth0.com/api/v2/users/USER_ID',

    domain: useProdNetsuite ? 'accounts.semi.org' : 'dev-accounts.semi.org',

    clientId: useProdNetsuite ? '6ybxRpBoarwWLKn5bKLyMzIZiLZyqebo' : 'dXsnca8hYv8kXVMDx4EB7fngrr6FBzQ3',

    responseType: useProdNetsuite ? 'token id_token' : 'token id_token',
  },
};
